import { useState } from "react";

export const useForm = (callback, initialState = {}) => {
  const [values, setValues] = useState(initialState);

  const onChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleDropdownChange = (event, data) => {
    setValues({ ...values, [data.name]: data.value });
  };

  const onSubmit = (event, data) => {
    event.preventDefault();
    callback();
  };

  return {
    onChange,
    handleDropdownChange,
    onSubmit,
    values,
  };
};
